import { Icon } from '@sr/ui-library';

const GetStartedOnboardingStep = () => {
  return (
    <div className="intro flex flex-col items-center justify-center gap-5 self-stretch py-5">
      <div className="flex flex-col items-center justify-center gap-8 self-stretch">
        <Icon className="h-16 w-16 text-primary" icon="person" />
        <h2>Confirm Your Clients</h2>
        <p className="intro-text text-center text-sr-default">
          Please confirm the representation status of each of your clients. If
          you have any past clients that you no longer represent but are able to
          make claims for, you will still be able to view these clients under
          Clients.
        </p>
      </div>
    </div>
  );
};

export default GetStartedOnboardingStep;
